import { useSyncExternalStore } from "react";

export function useIsRtl() {
    return useSyncExternalStore(subscribeToRtl, getRtlSnapshot, () => false);
}

function subscribeToRtl(onStoreChange: () => void) {
    const observer = new MutationObserver(onStoreChange);
    observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["dir", "class", "style"],
    });
    if (document.body) {
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ["dir", "class", "style"],
        });
    }
    return () => observer.disconnect();
}

function getRtlSnapshot() {
    const explicitDir =
        document.documentElement.getAttribute("dir") ??
        document.body?.getAttribute("dir");
    if (explicitDir === "rtl" || explicitDir === "ltr") {
        return explicitDir === "rtl";
    }
    return getComputedStyle(document.documentElement).direction === "rtl";
}
